import { Space, Button } from 'antd';
import { useEffect, useState } from 'react';
import { getLabList, sendMessage } from '../../api/api';
import type { ColumnsType } from 'antd/es/table';
import { errorNotify, sucessNotify } from '../../services/toast.notification';
import { useNavigate } from "react-router-dom";
import Search from './search';
import Spinner from '../../components/_common/Spinner';
import { Col, List, Row, Modal } from "antd";
import FormContainer from '../../components/FormContainer/FormContainer';
import CustomSelectAntDesign from '../../components/_common/CustomSelectAntDesign';
import { DeleteFilled } from '@ant-design/icons';
import { NoValidateForm } from '../../utility/validationRules';
import { useForm } from "../../utility/useForm";
import { SMSTextArea } from "./styles";
import CheckSite from './CheckSite';
import { useAppSelector } from '../../redux/store/storehooks';


const Proxy = () => {

  const columns: ColumnsType<any> = [
    { title: 'کد مرکز', dataIndex: 'prk_AndriodLab_AutoID', key: 'prk_AndriodLab_AutoID' },
    { title: 'نام', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName' },
    { title: 'استان', dataIndex: 'str_StateName', key: 'str_StateName' },
    { title: 'وب سرویس', dataIndex: 'str_TelegramAddress', key: 'str_TelegramAddress' },
    { title: 'تلفن مستقیم', dataIndex: 'str_DirectTel', key: 'str_DirectTel' },
    {
      title: '', dataIndex: 'Action', key: 'Action', render: (_, record) => (
        record.str_TelegramAddress ? (
          <Space size="middle">
            <Button type="primary" style={{ backgroundColor: "orange" }} onClick={() => showLabOnClick(record.prk_AndriodLab_AutoID, record.str_LabPersianName, record.str_DirectTel, record.str_CommercialSiteAddress, record.str_TelegramAddress, record.str_ServiceURL)}>مشاهده جزئیات</Button>
          </Space>
        ) :
          (
            <Space size="middle"></Space>
          )
      )
    },
    {
      title: '', dataIndex: 'Action', key: 'Action', render: (_, record) => (
        record.str_TelegramAddress ? (
          <Space size="middle">
            <Button type="primary" style={{ backgroundColor: "orange" }} onClick={() => showCheckModal(record.str_TelegramAddress)}>چک کردن سایت </Button>
          </Space>
        ) :
          (
            <Space size="middle"></Space>
          )
      )
    }
  ];

  const navigate = useNavigate();
  const myStore = useAppSelector((state) => state)
  const [isLoading, setIsLoading] = useState(true);
  const [type, setType] = useState("All");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [phoneNoList, setPhoneNoList] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [url, setUrl] = useState("");
  const [permission, setPermission] = useState(false);

  const { values, errors, handleSubmit, setErrors, setValues }
    = useForm(NoValidateForm) as any;

  const showCheckModal = (url: string) => {
    setUrl(url);
    setIsModalOpen(true);
  }
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  function onChangeValue(event: any) {
    setType(event.target.value);

    switch (event.target.value) {
      case 'All':
        setFilteredData(data);
        break;
      case 'Available':
        const _newFilter = data.filter((value: any) => {
          return value.str_TelegramAddress != "";
        });
        setFilteredData(_newFilter);
        break;
      case 'Unavailable':
        const newFilter = data.filter((value: any) => {
          return value.str_TelegramAddress == "";
        });
        setFilteredData(newFilter);
        break;
      case 'IsDebtor':
        const __newFilter = data.filter((value: any) => {
          return value.bit_Isdebtor == true;
        });
        setFilteredData(__newFilter);
        break;
    }
  }

  const showLabOnClick = (id: number, name: string, tel: string, website: string, url: string, serviceUrl: string) => {
    navigate('/parsicuser/labInfo', { state: { id: id, name: name, tel: tel, website: website, url: url, serviceUrl: serviceUrl } });
  }

  const checkSiteOnClick = (url: string) => {
    navigate('/parsicuser/checkSite', { state: { url: url } });
  }

  useEffect(() => {
    loadLabs();
    if (myStore.auth.loginType === 'parsicuser') {
      myStore.auth.permission.map((item: any) => {
        if (item.pageName == 'proxyPol')
          setPermission(item.isDetailAccess);
      });
    }
    else {
      setPermission(true);
    }
    //_sendMessage();  
  }, []);

  const loadLabs = () => {
    getLabList()
      .then((result: any) => {
        setData(result.data.data);
        setFilteredData(result.data.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage, undefined, 5000)
      })
  }

  const _sendMessage = (e: any) => {
    e.preventDefault();

    setIsSubmiting(true);
    let msgText = values.msgBody;
    let phoneNumbers: string[] = [];
    //phoneNumbers.push("09198808862");
    values.phoneNoList.map((item: any) => {
      phoneNumbers.push(item.mobileNumber);
    })
    sendMessage(msgText, phoneNumbers)
      .then((result: any) => {
        setIsSubmiting(false);
        setVisible(false);
        sucessNotify("پیامک ارسال شد.");
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage, undefined, 5000)
      })
  }

  const onCancel = () => {
    setValues((val: any) => ({
      ...val,
      phoneNoList: []
    }))
    setVisible(false);
  }

  const onNextClick = (e: any) => {

  }


  const phoneHandleChanges = (mobile: any) => {
    let selectedLab: any = filteredData.find((lab: any) => lab.str_ManagerMobile == mobile);
    if (selectedLab) {
      let findSelected = values.phoneNoList ? values.phoneNoList.find((item: any) => item === selectedLab.str_ManagerMobile) : null;
      if (findSelected) {
        errorNotify('این دستگاه قبلا انتخاب شده است', undefined, 5000)
        return
      }
      let myLabList = values.phoneNoList;

      if (!myLabList) {
        myLabList = [{
          mobileNumber: selectedLab.str_ManagerMobile,
          title: selectedLab.str_LabPersianName
        }]
      }
      else {
        myLabList.push({
          mobileNumber: selectedLab.str_ManagerMobile,
          title: selectedLab.str_LabPersianName
        })
      }
      setValues((val: any) => ({
        ...val,
        phoneNoList: myLabList
      }))

    }


  }

  const phoneHandleChanges_manual = (mobile: any) => {
    let myLabList = values.phoneNoList;

    if (!myLabList) {
      myLabList = [{
        mobileNumber: mobile,
        title: mobile
      }]
    }
    else {
      myLabList.push({
        mobileNumber: mobile,
        title: mobile
      })
    }

    setValues((val: any) => ({
      ...val,
      phoneNoList: myLabList
    }))
  }

  const removeLabFromList = (mobile: any) => {
    const newList = values.phoneNoList.filter((item: any) => item.mobileNumber !== mobile);

    setValues((val: any) => ({
      ...val,
      phoneNoList: newList
    }))
  }

  const showModal = () => {
    setVisible(true);
  }

  function handleChange(event: any) {
    const { name, value } = event.target;
    //setInputValue({ ...inputValues, [name]: value });
    setValues((val: any) => ({
      ...val,
      msgBody: value
    }))
  }

  return (
    <>
      {
        isLoading === false && (
          <div className="row" style={{ marginTop: '50px'}}>
              <div className={'d-flex justify-content-center gap-2'} onChange={onChangeValue} >
                <div className="form-check">
                  <input className="form-check-input" id={'rdoAll'} type="radio" value="All" name="Str_Type" checked={type === "All"}/>
                  <label className="form-check-label" htmlFor="rdoAll">همه</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" id={'rdoAvailable'} type="radio" value="Available" name="Str_Type" checked={type === "Available"}/>
                  <label className="form-check-label" htmlFor="rdoAvailable">در دسترس</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" id={'rdoUnavailable'} type="radio" value="Unavailable" name="Str_Type" checked={type === "Unavailable"}/>
                  <label className="form-check-label" htmlFor="rdoUnavailable">دور از دسترس</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" id={'rdoIsDebtor'} type="radio" value="IsDebtor" name="Str_Type" checked={type === "IsDebtor"}/>
                  <label className="form-check-label" htmlFor="rdoIsDebtor">بدهکار</label>
                </div>
              </div>
            <div className='col-md-12 col-sm-12'>
            <Button type="primary" disabled={!permission} onClick={showModal} style={{ backgroundColor: "blue", float: "left" }} >ارسال پیامک</Button>

            </div>

            <Search data={filteredData} columns={columns} permission={permission} />
            <div >
            </div>
          </div>

        )
      }
      {
        isLoading === true && (
          <Spinner />
        )
      }

      <Modal
        width={800}
        visible={visible}
        onCancel={onCancel}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { display: 'none' } }}
      >
        <>
          {isLoading === true && (
            <Spinner />
          )}

          {isLoading === false && (

            <FormContainer

              title="ارسال پیامک"

              saveButtonTitle={"ارسال"}
              onSubmit={_sendMessage}
              cancelButtonTitle={"لغو"}
              onCancel={onCancel}
              isLoading={isLoading}
              isSubmiting={isSubmiting}
            >
              <>
                <Row>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <CustomSelectAntDesign
                      name="mobile"
                      placeholder="شماره موبایل"
                      itemList={filteredData}
                      valueObjectField={"str_ManagerMobile"}
                      displayObjectField={"str_LabPersianName"}
                      showSearch={true}
                      onChange={(e: any) => phoneHandleChanges(e)}
                      onPressEnter={(e: any) => phoneHandleChanges_manual(e)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <List
                      header={
                        <Row>
                          <Col lg={23} md={23} sm={23} xs={23}>لیست</Col>
                        </Row>
                      }
                      style={{ margin: '10px' }}
                      footer={undefined}
                      bordered
                      dataSource={values.phoneNoList}
                      renderItem={(item: any, index: any) => (
                        <List.Item actions={
                          [
                            <DeleteFilled onClick={() => removeLabFromList(item.mobileNumber)} style={{ color: 'red', fontSize: '18px' }} />,
                          ]
                        }>
                          <>
                            <List.Item.Meta
                              description={item.title}
                            />
                          </>
                        </List.Item>
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <div className="form-control"
                    style={{ marginBottom: '18px' }} >
                    <SMSTextArea
                      placeholder="متن پیام"
                      id="msgBody"
                      name="msgBody"
                      onChange={(e) => handleChange(e)}
                      value={values.msgBody}
                    />
                  </div>
                </Row>
              </>
            </FormContainer>

          )}
        </>

      </Modal>


      <Modal style={{ direction: 'rtl' }} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[]} width={800}>
        <div className="form-control" style={{ marginBottom: '18px', direction: 'rtl' }} >
          <CheckSite url={url} />
        </div>
      </Modal>

    </>
  )
};

export default Proxy;
